import React from 'react'
import { useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import { css } from 'emotion'

const B2C_PATH = '/itineraires-b2c'
const B2B_PATH = '/companion'

/**
 * Bascule Charrette (itinéraires B2C) / Traiteur (companion B2B) pour un livreur au périmètre
 * « B2C et B2B » : il a les deux rôles (calculés par l'API selon son périmètre
 * et ses périodes d'accès B2C). Rien n'est affiché sinon.
 *
 * theme : 'light' sur le vert du header livreur (DriverHeader), 'dark' sur fond foncé
 */
const InterfaceSwitch = ({ theme = 'dark' }) => {
  const location = useLocation()
  const roles = useSelector((state) => state.common.user.data?.roles) || []

  if (!roles.includes('ROLE_PRO_COMPANION_USER') || !roles.includes('ROLE_B2C_LIVREUR')) {
    return null
  }

  const isB2C = location.pathname.startsWith(B2C_PATH)
  const s = styles(theme)

  return (
    <div className={`no-print ${css(s.switch)}`} role="group" aria-label="Changer d'interface">
      <Link to={B2C_PATH} className={css(s.option, isB2C && s.active)} aria-current={isB2C ? 'page' : undefined}>
        Charrette
      </Link>
      <Link to={B2B_PATH} className={css(s.option, !isB2C && s.active)} aria-current={!isB2C ? 'page' : undefined}>
        Traiteur
      </Link>
    </div>
  )
}

const styles = (theme) => {
  const color = theme === 'dark' ? '#fff' : '#1d1d1b'
  // Sur le vert du header livreur, l'onglet actif passe en foncé pour rester lisible
  const activeBackground = theme === 'dark' ? '#429853' : '#1d1d1b'

  return {
    switch: {
      display: 'inline-flex',
      flexShrink: 0,
      border: `1px solid ${color}`,
      borderRadius: '4px',
      overflow: 'hidden'
    },
    option: {
      padding: '4px 8px',
      fontSize: '0.85rem',
      color: color,
      fontWeight: 'bold',
      textDecoration: 'none',
      ':hover': {
        color: color,
        textDecoration: 'none',
        backgroundColor: 'rgba(66, 152, 83, 0.35)'
      }
    },
    active: {
      backgroundColor: activeBackground,
      color: '#fff',
      ':hover': {
        color: '#fff',
        backgroundColor: activeBackground
      }
    }
  }
}

export default InterfaceSwitch
